import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private currentToken: string = '';

  constructor(
    private router: Router,
    private zone: NgZone,
  ) {}

  public async initialize() {
    // Only configure pushing on native devices
    if (!Capacitor.isNativePlatform()) return;

    try {
      // 1. Request permissions for Local Notifications
      await LocalNotifications.requestPermissions();

      // 2. Request permissions for FCM
      const { receive } = await FirebaseMessaging.requestPermissions();
      if (receive === 'granted') {
        // 3. Setup Android 8+ Notification Channels for BOTH FCM and Local
        if (Capacitor.getPlatform() === 'android') {
          // FCM Background Channel
          await FirebaseMessaging.createChannel({
            id: 'auton_push_channel',
            name: 'Important Notifications',
            description: 'General App Notifications',
            importance: 4,
            visibility: 1,
            vibration: true,
          });

          // Local Foreground Channel (v2 strictly bypassing OS caching)
          await LocalNotifications.createChannel({
            id: 'auton_local_channel_high_v2',
            name: 'Important Local Notifications',
            description: 'Foreground Alert Notifications',
            importance: 5, // 5 = IMPORTANCE_HIGH (Absolute requirement for Heads-up Banners)
            visibility: 1,
            vibration: true,
          });
        }

        // 4. Get FCM Token
        const tokenResult = await FirebaseMessaging.getToken();
        this.currentToken = tokenResult.token;
        console.log('==== FCM TOKEN ====');
        console.log(this.currentToken);

        // 5. Register Listeners
        this.onNotification();
        this.onNotificationActionPerformed();
      }
    } catch (e) {
      console.error('FCM Initialization Error:', e);
    }
  }

  public getToken(): string {
    return this.currentToken;
  }

  private onNotification() {
    // Handles notifications when the app is explicitly open (FOREGROUND)
    FirebaseMessaging.addListener('notificationReceived', async (event) => {
      console.log('Foreground Push Received:', event);

      const title = event.notification.title || 'New Notification';
      const body = event.notification.body || 'You have a new message.';

      try {
        await LocalNotifications.schedule({
          notifications: [
            {
              title: title,
              body: body,
              id: Math.floor(Math.random() * 2147483647), // strict Java 32-bit int unique ID
              channelId: 'auton_local_channel_high_v2',
            },
          ],
        });
        console.log('Local Notification Scheduled Successfully!');
      } catch (err) {
        console.error('Failed to schedule local notification:', err);
      }
    });
  }

  private onNotificationActionPerformed() {
    // Handling taps for Local Notifications (Foreground Tap)
    LocalNotifications.addListener(
      'localNotificationActionPerformed',
      (event) => {
        console.log('User Tapped Local Action:', event);
        this.zone.run(() => {
          this.router.navigateByUrl('/dashboard');
        });
      },
    );

    // Handling taps for FCM Push Notifications (Background Tap)
    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      console.log('User Tapped Push Action:', event);
      this.zone.run(() => {
        this.router.navigateByUrl('/dashboard');
      });
    });
  }
}
